import Content from '../../content.js';

namespace('IO.Views.VirtualNodes', function (exports) {
  'use strict';

  var VirtualNodeShowView = exports.Show,
    Index = Content.extend({
      dom: {
        VIRTUAL_NODE: '.virtual-node-list-item.rje-enabled',
      },

      /*
        PUBLIC FUNCTIONS
      */
      onInitialization: function () {},

      onDestroy: function () {
        _.each(this.virtualNodeViews, function (item) {
          item.destroy();
        });
      },

      render: function () {
        var $virtualNodes = this.$(this.dom.VIRTUAL_NODE);

        this.virtualNodeViews = this.virtualNodeViews || [];
        _.each(
          $virtualNodes,
          _.bind(function (el) {
            var $el = $(el),
              name = $el.find('.vnode-title').data('name'),
              virtualNode;

            virtualNode = new VirtualNodeShowView({
              el: $el,
              name: name,
              poll: this.options.poll,
            });
            this.virtualNodeViews.push(virtualNode);
          }, this),
        );
      },
    });

  exports.Index = Index;
});
